import { TFunction } from 'react-i18next';
import { DESTINATION_TABLE_COLUMN, DestinationTableHeader } from '../types';
import { MenuItemOption } from 'ui/menu';
import { FILTER_IDS } from '../constants';

export const getDestinationTableHeaders = (t: TFunction): DestinationTableHeader[] => {
  return [
    {
      id: DESTINATION_TABLE_COLUMN.NAME,
      label: t('table.destination.header.name'),
    },
    {
      id: DESTINATION_TABLE_COLUMN.STATUS,
      label: t('table.destination.header.status'),
    },
    {
      id: DESTINATION_TABLE_COLUMN.LAST_SYNC,
      label: t('table.destination.header.lastSync'),
    },
    {
      id: DESTINATION_TABLE_COLUMN.LAST_MODIFIED,
      label: t('table.destination.header.lastModified'),
    },
  ];
};

export const getDestinationTableFilterMenu = (t: TFunction): MenuItemOption[] => [
  {
    label: t('table.destination.filter.showArchivedDestinations') ?? 'Show archived destinations',
    hasFilter: true,
    hasCountBadge: false,
    id: FILTER_IDS.SHOW_ARCHIVED_DESTINATIONS,
  },
];
